import { Link } from "react-router-dom";
import { ArrowLeft, Headphones } from "lucide-react";

export function PublicInfoLayout({ eyebrow, title, children }) {
  return (
    <main className="min-h-screen bg-[#050505] text-zinc-100">
      <header className="border-b border-white/[0.06]">
        <nav className="max-w-5xl mx-auto flex items-center justify-between px-6 py-5">
          <Link to="/" className="flex items-center gap-2.5 group">
            <span className="w-9 h-9 rounded-lg bg-[#C5A059]/10 border border-[#C5A059]/30 flex items-center justify-center group-hover:bg-[#C5A059]/20 transition-colors">
              <Headphones className="w-4 h-4 text-[#C5A059]" strokeWidth={1.6} />
            </span>
            <span className="font-heading text-lg font-semibold tracking-tight text-white">
              Kiru<span className="text-[#C5A059]">·</span>beezy
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm font-medium text-zinc-300 transition-colors hover:border-white/20 hover:bg-white/[0.04] hover:text-white"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.8} />
            Home
          </Link>
        </nav>
      </header>

      <section className="px-6 py-16 md:py-24">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C5A059] font-semibold">
            {eyebrow}
          </p>
          <h1 className="mt-5 font-heading text-4xl md:text-6xl font-bold tracking-tighter text-white">
            {title}
          </h1>
          <div className="mt-10 space-y-8 text-left text-zinc-300 leading-7">
            {children}
          </div>
        </div>
      </section>
    </main>
  );
}
